import { withTriggerCombobox } from '@platejs/combobox'
import { createPlatePlugin } from 'platejs/react'
import type { AnyPlatePlugin } from 'platejs/react'

import type { BufferEditor } from '~publish/legacy/editor/BufferEditor/types.plate'

import type { AutocompletePluginOptions } from '../autocomplete'
import { replaceTextAfterTriggerWithMention } from '../autocomplete/transforms/replaceTextAfterTriggerWithMention'
import { withInsertTriggerBeforeText } from '../autocomplete/withInsertTriggerBeforeText'
import { getNewSuggestionsOnMentionUpdate } from './api/getNewSuggestionsOnMentionUpdate'
import { findAndInsertLinkedInAnnotations } from './commands/findAndInsertLinkedInAnnotations'
import { getAllLinkedInAnnotations } from './commands/getAllLinkedInAnnotations'
import { insertLinkedInAnnotation } from './commands/insertLinkedInAnnotation'
import { LinkedInAnnotationInputElement } from './nodes/LinkedInAnnotationInputElement'
import { onSelectItem } from './queries/recentSuggestions'
import { LinkedInMentionUI } from './ui/LinkedInMentionUI'

// Not returned directly from the arrow function: an explicit return type on
// the expression itself back-propagates into createPlatePlugin's own
// generic inference and corrupts it (options/node end up typed against the
// annotation's defaults instead of the literal passed in).
export const createLinkedInAnnotationPlugin = (): AnyPlatePlugin => {
  const createdPlugin = createPlatePlugin({
    key: LinkedInAnnotationInputElement.type,
    node: {
      isElement: true,
      isInline: true,
      isVoid: true,
      component: LinkedInMentionUI,
    },
    options: {
      trigger: LinkedInAnnotationInputElement.trigger,
      triggerPreviousCharPattern: /^\s?$/,
      createComboboxInput: () => LinkedInAnnotationInputElement.new(),
      textToNodes: findAndInsertLinkedInAnnotations,
      fetchNewSuggestions: getNewSuggestionsOnMentionUpdate,
      fetchDebounceMs: 200,
      onInsertTriggerBeforeText: replaceTextAfterTriggerWithMention,
      onSelectItem,
    } as AutocompletePluginOptions<LinkedInAnnotationInputElement>,
    extendEditor: ({ editor: rawEditor }) => {
      const editor = rawEditor as unknown as BufferEditor
      editor.insertLinkedInAnnotation = insertLinkedInAnnotation
      editor.getAllLinkedInAnnotations = getAllLinkedInAnnotations
      return editor
    },
  })
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .overrideEditor(withTriggerCombobox as any)
    .overrideEditor(
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      withInsertTriggerBeforeText(LinkedInAnnotationInputElement) as any,
    )
  return createdPlugin
}
